import { storageRef } from "./firebase"

const storageImages = storageRef("images/");

export const uploadImage = async (name: string, image: string) =>
    (await storageImages.ref(name).uploadString(image, "data_url")).getDownloadURL();